import { FormattedMessage } from 'react-intl';
import moment from 'moment-timezone';
import React, { useEffect } from 'react';
import { usePasswordComplexity } from '../../../../context/use-password-complexity';
import { Body, Container, Title } from '../../../../common/components';

export const PasswordResetDelay = ({
  afterDelayHandler,
  resetAt,
  timezone
}: {
  afterDelayHandler: () => void;
  resetAt: string;
  timezone: string;
}) => {
  const { passwordComplexityLifetimeMinutesMin } = usePasswordComplexity();

  const deadline = moment(resetAt).add(passwordComplexityLifetimeMinutesMin, 'minutes');
  useEffect(() => {
    const timer = setTimeout(afterDelayHandler, moment.duration(deadline.diff(moment())).asMilliseconds());

    return () => clearTimeout(timer);
  }, [afterDelayHandler, deadline]);

  return (
    <Container>
      <Title>
        <FormattedMessage id="passwordReset" defaultMessage="Password reset" />
      </Title>
      <Body marginStrategy="bottom">
        <FormattedMessage id="passwordResetOn" defaultMessage="You can change your password again at:" />
        {` ${deadline.tz(timezone).format('h:mm A - D MMM YYYY')}`}
      </Body>
    </Container>
  );
};
